<template>
  <div class="grid grid-cols-7 gap-y-4 pt-2 my-justify-self-center bg-white dark:bg-dark-500">
    <div
      v-for="(step, idx) in judgeStepList"
      :key="`circle-${step}`"
      class="relative material-icons text-3xl flex justify-center text-gray-800 dark:text-dark-text"
      :class="{
        'right-border': idx !== len - 1,
        'left-border': idx !== 0
      }"
    >
      <div v-if="idx < findedIdx" class="text-accept dark:text-teal-700"> check_circle </div>
      <div v-else-if="idx === findedIdx" class="text-reject dark:text-red-800"> error </div>
      <div v-else>radio_button_unchecked</div>
    </div>
    <div v-for="step in judgeStepList" :key="`disc-${step}`" class="flex justify-center pt-2 pb-2">
      <div class="font-bold mx-1 text-gray-800 dark:text-dark-text" style="font-size: 0.5vw">
        {{ step }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props: {
    judgeStepList: {
      type: Array,
      required: true
    },
    currentJudgeStep: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const len = props.judgeStepList.length

    const findedIdx = computed(() =>
      props.currentJudgeStep === 'ACCEPTED' ? len : props.judgeStepList.findIndex(v => v === props.currentJudgeStep)
    )

    return {
      len,
      findedIdx
    }
  }
})
</script>

<style scoped>
.left-border::before {
  content: '';
  position: absolute;
  width: calc(100% / 2 - 0.8rem);
  left: 0rem;
  top: 0.91rem;
  border-bottom: 2px #b0bec5 solid;
}

.right-border::after {
  content: '';
  position: absolute;
  width: calc(100% / 2 - 0.8rem);
  right: 0rem;
  top: 0.91rem;
  border-bottom: 2px #b0bec5 solid;
}

.my-justify-self-center {
  justify-self: center;
}
</style>
